import { Field, FieldControllerType } from '@gemini/lux-ds-pms';
import { CustomTranslationFnc } from '@hooks/useCustomTranslation';

const contactsDetailsForm = (
  t: CustomTranslationFnc,
  isBranded?: boolean,
): Field[] => {
  return [
    // {
    //   id: 'contactsDetails.sameAsPatientDetails',
    //   labelKey: 'fieldsLabel.sameAsPatientDetails',
    //   type: FieldControllerType.CHECKBOX,
    //   visibility: true,
    //   disabled: false,
    //   size: {
    //     xs: 12,
    //     md: 12,
    //     lg: 12,
    //   },
    // },
    {
      id: 'contactsDetails.firstName',
      labelKey: 'fieldsLabel.firstName',
      type: FieldControllerType.TEXT,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 6,
        lg: 6,
      },
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
        {
          type: 'regex',
          value: /^[A-Za-z\s]+$/,
          errorMsgKey: 'fieldsLabel.errors.onlyLetters',
        },
      ],
      otherOptions: {
        text: {
          hideStatusAdornments: isBranded,
        },
      },
    },
    {
      id: 'contactsDetails.lastName',
      labelKey: 'fieldsLabel.lastName',
      type: FieldControllerType.TEXT,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 6,
        lg: 6,
      },
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
        {
          type: 'regex',
          value: /^[A-Za-z\s]+$/,
          errorMsgKey: 'fieldsLabel.errors.onlyLetters',
        },
      ],
      otherOptions: {
        text: {
          hideStatusAdornments: isBranded,
        },
      },
    },
    {
      id: 'contactsDetails.dateOfBirth',
      labelKey: 'fieldsLabel.dob',
      type: FieldControllerType.DATEPICKER,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 6,
        lg: 6,
      },
      otherOptions: {
        datePicker: {
          disableFuture: true,
          minDate: new Date(1753, 0, 1),
          maxDate: new Date(),
          msgInvalid: t('fieldsLabel.errors.dobInvalid'),
          msgMinDate: t('fieldsLabel.errors.dobInvalid'),
          msgMaxDate: t('fieldsLabel.errors.dateInFuture'),
          isMonthPicker: true,
          pickDay: true,
        },
      },
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
      ],
    },
    {
      id: 'contactsDetails.email',
      labelKey: 'fieldsLabel.email',
      type: FieldControllerType.TEXT,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 6,
        lg: 6,
      },
      validations: [
        {
          type: 'required',
          value: true,
          errorMsgKey: 'fieldsLabel.errors.isRequired',
        },
        {
          type: 'regex',
          value:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
          errorMsgKey: 'fieldsLabel.errors.email',
        },
      ],
      otherOptions: {
        text: {
          hideStatusAdornments: isBranded,
        },
      },
    },
    {
      id: 'contactsDetails.phone',
      type: FieldControllerType.GROUP,
      visibility: true,
      disabled: false,
      size: {
        xs: 12,
        md: 12,
        lg: 12,
      },
      children: [
        {
          id: 'contactsDetails.phone.number',
          labelKey: 'fieldsLabel.phoneNumber',
          otherOptions: {
            phone: {
              prefixId: 'contactsDetails.phone.prefix',
              showPrefixAsText: true,
            },
            text: {
              hideStatusAdornments: isBranded,
            },
          },
          type: FieldControllerType.PHONE,
          visibility: true,
          disabled: false,
          size: {
            xs: 12,
            md: 12,
            lg: 8,
          },
          validations: [
            {
              type: 'required',
              value: true,
              errorMsgKey: 'fieldsLabel.errors.isRequired',
            },
            {
              type: 'validate',
              value: 0,
              errorMsgKey: 'fieldsLabel.errors.phoneInvalid',
            },
          ],
        },
        {
          id: 'contactsDetails.phone.type',
          type: FieldControllerType.RADIO,
          visibility: false,
          disabled: false,
          size: {
            xs: 12,
            md: 12,
            lg: 4,
          }, // 6 per metà, 12 intero
          options: [
            { key: 'mobile', label: 'fieldsLabel.mobile' },
            { key: 'landline', label: 'fieldsLabel.landline' },
          ],
          validations: [
            {
              type: 'required',
              value: true,
              errorMsgKey: 'fieldsLabel.errors.isRequired',
            },
          ],
        },
      ],
    },
  ];
};

export default contactsDetailsForm;
